module.exports = __webpack_public_path__ + "static/media/ev4.d9cdc591.webp";